import BaseModel from '@core/model';

import SubscriptionTypeEnum from '@constants/enums/subscription/type';

import BillingGroup from '@/models/BillingGroup';
import RatePlan from '@/models/RatePlan';

export class Subscription extends BaseModel {
    static name = 'Subscription';
    static entity = 'subscriptions';

    static fields() {
        return {
            ...super.fields(),
            id: this.attr(null),
            billing_group_id: this.string(null).nullable(),
            billing_group: this.belongsTo(BillingGroup, 'billing_group_id'),
            rate_plan_id: this.string(null).nullable(),
            rate_plan: this.belongsTo(RatePlan, 'rate_plan_id'),
            subscription_type: this.enum(SubscriptionTypeEnum).nullable(),
            date_range: this.attr(null).nullable(),
            investor_id: this.string(null).nullable(),
            adviser_id: this.string(null).nullable()
        };
    }

    static mock(overrides = {}) {
        return {
            id: faker => faker.string.uuid(),
            billing_group_id: faker => overrides.billing_group_id || faker.string.uuid(),
            rate_plan_id: faker => overrides.rate_plan_id || faker.string.uuid(),
            subscription_type: faker =>
                overrides.subscription_type || faker.helpers.arrayElement(Object.values(SubscriptionTypeEnum)),
            date_range: () => ({
                start: '2024-01-01',
                end: null
            }),
            investor_id: faker => overrides.investor_id || faker.string.uuid(),
            adviser_id: faker => overrides.adviser_id || faker.string.uuid()
        };
    }
}

export default Subscription;
